import React from "react";
import VinicaSecondModalForm from "./VinicaSecModal";
import { Select } from "antd";
import services from "../../../../services";
import { Button } from "@progress/kendo-react-buttons";
import moment from "moment";
import { toast } from "react-toastify";
import { Tooltip } from "@progress/kendo-react-tooltip";
import { Input } from "@progress/kendo-react-inputs";
import queryString from 'query-string'

const { Option } = Select;

const userKeys = [
    "idInstalacaoVinica",
    "idInstalacaoVinica_Entidade",
    "codEntidade",
    "nome",
    //"entidadePrincipal",
    //"dataCriado",
    //"dataModificado"
];

class VinicaListModalForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            IdenUser: {
                Instalação: "",
                Utilizadores: "",
            },
            popUpForm: "",
            data: [],
            entityDataList: [],
            searchValid: 0,
            optionsEntityList: "",
            entity_list_object: {},
            defaultSelection: "",
            displayDataArray: [],
            entidade: "",
            nif: "",
        };
    }

    /* Esta é a primeira etapa após o construxctor para carregar este componente  */

    componentDidMount() {
        let data = this.props.tabShowData;
        this.getAllUser();
        let IdenUser = this.props.IdenUser;
        this.setState({
            data,
            IdenUser,
        });
    }

    getAllUser = async () => {
        let params = queryString.parse(window.location.search)
        let idInstalacao = params.idInstalacao;
        //https://localhost:44397/api/InstalacaoVinica/GetUsers
        let link = "InstalacaoVinica/GetUsers";
        let allUser = [];
        let request = {
            idInstalacaoVinicaDecrypt: idInstalacao,
        };
        let res = await services.apiCall.requestApi(link, request, "post");
        // console.log("uuuser users ", res.codEntidade);
        if (res) {
            allUser = res;
        }
      
        this.setState({
            displayDataArray: res
        })
    };

    defaultLoader = () => {};

    createUserArray = () => {
        let testArray = [...this.state.displayDataArray];
        let submitArray = [];
        let requestArray = [];
        let todayDate = new Date();

        testArray.map((obj) => {
            if (!obj["idInstalacaoVinica_Entidade"]) {
                submitArray.push(obj);
            }
        });
        submitArray.map((obj) => {
            let submitObj = {};
            userKeys.map((key) => {
                if (key === "idInstalacaoVinica") {
                    submitObj[key] = this.props.idInstalacaoVinica;
                } else if (key === "idInstalacaoVinica_Entidade") {
                    submitObj[key] = 0;
                } else if (key === "codEntidade") {
                    submitObj[key] = obj.codEntidade.toString();
                } else if (key === "nome") {
                    submitObj[key] = obj.nome;
                }
                // else if(key === "entidadePrincipal") {
                //    if(obj.nif === this.state.IdenUser["Utilizadores"] &&
                //       this.state.IdenUser["utilizadorDetail"] === "verbal") {
                //          submitObj[key] = 1
                //       }

                //    else if(obj.nif === this.state.IdenUser["Utilizadores"] &&
                //    this.state.IdenUser["utilizadorDetail"] === "documental") {
                //       submitObj[key] = 2
                //    }

                //    else submitObj[key] = 0
                // }
                // else if(key === "dataCriado") {
                //    submitObj[key] = moment(todayDate).format("YYYY-MM-DD")
                // }
                // else if(key === "dataModificado") {
                //    submitObj[key] = todayDate
                // }
            });
            delete submitObj.dataModificado;
            requestArray.push(submitObj);
        });
        console.log("the requestArray is ", requestArray);
        return requestArray;
    };

    createArrayAPI = async (requestArray) => {
        let link = "InstalacaoVinica/InsertUser";
        let request = [...requestArray];
        let method = "post";
        let res = await services.apiCall.requestApi(link, request, method);
        if (res) {
            return {
                status: true,
                res: res,
            };
        } else {
            //toast.error("Failed to create user!")
            return {
                status: false,
                res: [],
            };
        }
    };

    updateStoredArray = (res) => {
        let { tab } = this.props;
        this.setState(
            {
                displayDataArray: [...res],
            },
            () => {
                let { data, displayDataArray, IdenUser } = this.state;
                this.props.getDataToPanel(
                    data,
                    displayDataArray,
                    IdenUser,
                    tab
                );
            }
        );
    };

    componentDidUpdate(prevProps) {
        if (prevProps.date !== this.props.date) {
            let data = this.props.tabShowData;
            let displayDataArray = this.props.displayDataArray;
            this.setState({
                data,
                displayDataArray,
            });
        }
    }

    onSearch = async (e) => {
        if (e.length >= 3) {
            let res = await services.EntityList.getEntityList("parcel", e);
            if (res) {
                this.setState(
                    {
                        entityDataList: res.entityList,
                        entity_list_object: res.entity_row,
                        searchValid: e.length,
                    },
                    () => this.entityListOption()
                );
            }
        } else {
            this.setState({
                searchValid: 0,
            });
        }
        this.setState({ defaultSelection: e });
    };

    entityListOption = () => {
        let optionsEntityList = this.state.entityDataList.map((_r, i) => (
            <Option key={_r.nif} value={_r.nif}>
                {_r.nome}
                <br />
                {_r.nifap}
            </Option>
        ));

        this.setState({
            optionsEntityList,
        });
    };

    handleSelect = async (value) => {
        try {
            await this.entitypermissoncheck(value);
            this.setState({
                defaultSelection: null,
                optionsEntityList: "",
            });
        } catch (error) {
            this.setState({ error });
        }
    };

    handleChange = (e) => {
        let { name, value } = e.target;
        console.log("value in e 800", name, value);
        this.setState({
            [name]: value,
        });
    };
    entitypermissoncheck = async (nif) => {
        let displayObject;
        let displayDataArray = [...this.state.displayDataArray];
        let id = this.state.entity_list_object[nif].codEntidade;
        let data = {
            id: Number(id),
            modulename: "parcel",
        };
        let res = await services.apiCall.requestApi(
            "/Entity/CheckPermission",
            data,
            "post"
        );
        if (res) {
            var count = 0;
            displayObject = this.state.entity_list_object[nif];
            if (displayDataArray.length > 0) {
                displayDataArray.map((_k) => {
                    if (_k["nifap"] === displayObject["nifap"]) {
                        count = count + 1;
                    }
                });
            }
            if (count === 0) {
                displayDataArray.push(displayObject);
                console.log("display data array push listModal");
            }

            this.setState(
                {
                    displayDataArray,
                },
                () => {
                    let newEntityId = {
                        nif: nif,
                    };
                    this.addDatatoMainData(newEntityId);
                }
            );
        }
    };

    addDatatoMainData = (setdata) => {
        let data = [];
        let alreadySet = false;
        if (this.state.data) {
            data = [...this.state.data];
        }
        data.map((_r, i) => {
            if (_r.nif && _r.nif.trim() === setdata.nif) {
                alreadySet = true;
                if (Object.keys(setdata).length > 1) data[i] = setdata;
            }
        });
        if (!alreadySet) {
            data.push(setdata);
            console.log("data push listModal");
        }
        this.setState(
            {
                data,
            },
            async () => {
                if (
                    this.props.tab === "Instalação" &&
                    this.state.IdenUser[this.props.tab]
                ) {
                    let { data, displayDataArray, IdenUser } = this.state;
                    let { tab } = this.props;
                    this.props.getDataToPanel(
                        data,
                        displayDataArray,
                        IdenUser,
                        tab
                    );
                } else if (this.props.tab === "Utilizadores") {
                    let requestArray = this.createUserArray();
                    let res = await this.createArrayAPI(requestArray);

                    if (res.status) {
                        this.updateStoredArray(res.res);
                    } else {
                        toast.error("failed to store user!");
                        return;
                    }
                }
            }
        );
    };

    setIdenUser = (nif, detail, tab) => {
        let IdenUser = { ...this.state.IdenUser };
        if (tab === "Instalação") {
            IdenUser["instalacaoDetail"] = detail;
        } else if (tab === "Utilizadores") {
            IdenUser["utilizadorDetail"] = detail;
        }
        IdenUser[tab] = nif;
        this.setState(
            {
                IdenUser,
            },
            async () => {
                console.log("yes it worked IdenUser");
                if (this.props.tab === "Utilizadores") {
                    let requestArray = this.createUserArray();
                    let res = await this.createArrayAPI(requestArray);

                    if (res.status) {
                        this.updateStoredArray(res.res);
                    } else {
                        toast.error("failed to store user!");
                        return;
                    }
                } else {
                    let { data, displayDataArray, IdenUser } = this.state;
                    this.props.getDataToPanel(
                        data,
                        displayDataArray,
                        IdenUser,
                        tab
                    );
                }
            }
        );
    };

    popUpDetailEntry = (row) => {
        let popUpForm = (
            <VinicaSecondModalForm
                tab={this.props.tab}
                date={new Date()}
                closePopup={() => this.props.closePopup()}
                entity={row}
                getPanelData={(data) => this.getPanelData(data)}
                IdenUser={this.props.IdenUser}
                setIdenUser={(nif, detail, tab) =>
                    this.setIdenUser(nif, detail, tab)
                }
                data={this.state.data}
            />
        );
        this.setState({
            popUpForm,
        });
    };

    deleteEntry = async (row) => {
        let { vasilhaUserArray } = this.props;
        let newDisplayDataArray;
        let newData = this.state.data.filter((entry) => entry.nif != row.nif);
        let cond;
        if (vasilhaUserArray.length > 0) {
            if (
                this.checkVasilahOwner(
                    row.codEntidade,
                    vasilhaUserArray[0].codEntidade
                )
            ) {
                cond = true;
            }
        } else if (vasilhaUserArray.length === 0) {
            cond = true;
        } else {
            toast.error(
                "A entidade que pretende excluir está associada a vasilhas. Por favor reveja esta informação."
            );
            return;
        }
        if (this.props.tab === "Utilizadores") {
            // console.log("rrrrrrrrrrrrrrrrrrrrr",this.props.vasilhaUserArray,row.codEntidade)
            let request = {};
            let link = "InstalacaoVinica/RemoveUser";
            let method = "post";
            request["idInstalacaoVinica"] = row["idInstalacaoVinica"];
            request["idInstalacaoVinica_Entidade"] =
                row["idInstalacaoVinica_Entidade"];
            let res;
            if (cond) {
                res = await services.apiCall.requestApi(link, request, method);
            }
            if (res) {
                newDisplayDataArray = res;
            } else {
                toast.error("Falha ao remover usuário!");
                return;
            }
        } else {
            newDisplayDataArray = this.state.displayDataArray.filter(
                (entry) => row.nif != entry.nif
            );
        }

        this.setState(
            {
                displayDataArray: newDisplayDataArray,
                data: newData,
            },
            () => {
                let { tab } = this.props;
                let { data, displayDataArray, IdenUser } = this.state;
                this.props.getDataToPanel(
                    data,
                    displayDataArray,
                    IdenUser,
                    tab
                );
            }
        );
    };

    checkVasilahOwner = (user, vasilahuser) => {
        // console.log("rrrrrrrrrrrrrrrr",user,vasilahuser)
        if (user !== vasilahuser) return true;
        else return false;
    };

    handleFechar = () => {
        let data = {};
        let displayDataArray = {
            Instalação: [],
            Utilizadores: [],
        };
        this.setState({
            data,
            displayDataArray,
        });
        this.props.closePopup();
    };

    handleNewEntidade = async () => {
        try {
            let res = await services.apiCall.requestApi(
                "InstalacaoVinica/InsertEntidade",
                {
                    nif: this.state.nif,
                    nome: this.state.entidade,
                },
                "post"
            );
            if (res) {
                this.setState({
                    displayDataArray: [
                        ...this.state.displayDataArray,
                        {
                            codEntidade: res.codEntidade,
                            codPais2nif: "",
                            nif: res.nif,
                            nifap: "",
                            nome: res.nome,
                        },
                    ],
                });
            }
        } catch (error) {
            console.log(error);
        }
    };

    render() {
        return (
            <div className="modal-content">
                <div className="modal-header">
                    <h4 className="modal-title pl-0">
                        Associar{" "}
                        {this.props.tab === "Instalação"
                            ? "Propriétario"
                            : "Utilizadores"}
                    </h4>
                    {/* <button type="button" className="btn btn-success btn-sm text-uppercase mr-3">Guardar</button>  */}
                    <Button
                        onClick={() => this.handleFechar()}
                        primary={true}
                        className="remoove btn-ivdp-primary cursor-pointer mr-2"
                    >
                        Fechar
                    </Button>
                </div>
                <div className="modal-body">
                    <div className="form-group position-relative">
                        <div className="input-box active-grey">
                            <Select
                                disabled={
                                    this.props.tab === "Instalação" &&
                                    this.state.displayDataArray.length > 0
                                        ? 1
                                        : 0
                                }
                                onChange={this.handleSelect}
                                showSearch
                                onSearch={this.onSearch}
                                style={{ width: "100%" }}
                                value={this.state.defaultSelection || ""}
                                placeholder="Pesquisar por Nº ou Nome"
                                optionFilterProp="children"
                                notFoundContent="Entidade não encontrada, refina os critérios de pesquisa"
                            >
                                {/* <Option value="" disabled>Pesquise por Nome ou Nº</Option>  */}
                                {this.state.searchValid >= 3 &&
                                    this.state.optionsEntityList}
                            </Select>
                        </div>
                        {/* <div className="col-md-6">
                            <div className="input-box active-grey">
                                <Input
                                    name="entidade"
                                    value={this.state.entidade}
                                    onChange={(e) => this.handleChange(e)}
                                    style={{ width: "100%" }}
                                    className="input-1"
                                    label="Entidade Proprietária"
                                    readOnly={
                                        this.props.tab === "Instalação" &&
                                        this.state.displayDataArray.length > 0
                                            ? 1 : 0
                                    }
                                />
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="input-box active-grey">
                                <Input
                                    name="nif"
                                    value={this.state.nif}
                                    onChange={(e) => this.handleChange(e)}
                                    style={{ width: "100%" }}
                                    className="input-1"
                                    label="NIF"
                                    readOnly={
                                        this.props.tab === "Instalação" &&
                                        this.state.displayDataArray.length > 0
                                            ? 1
                                            : 0
                                    }
                                />
                            </div>
                        </div> */}
                        {/* <Button
                            primary
                            className="remoove btn-ivdp-primary cursor-pointer ml-3"
                            onClick={this.handleNewEntidade}
                        >
                            adicionar entidade
                        </Button> */}
                        <span className="cursor-pointer search-icon">
                            <i className="fas fa-search"></i>
                        </span>
                        {this.state.data &&
                        this.state.displayDataArray &&
                        this.state.displayDataArray.length > 0 ? (
                            this.state.displayDataArray.map(
                                (_r, i) =>
                                    _r.nif && (
                                        <div
                                            className="listing"
                                            key={i}
                                            style={
                                                this.props.tab ===
                                                "Utilizadores"
                                                    ? {
                                                          borderBottom:
                                                              "1px solid lightGrey",
                                                      }
                                                    : {}
                                            }
                                        >
                                            <span className="d-flex justify-content-between cursor-pointer align-items-center">
                                                <div>
                                                    <p className="top-head m-0">
                                                        {_r.nome}
                                                    </p>
                                                    <p className="small font-14 m-0">
                                                        {_r.nif}
                                                    </p>
                                                    {this.props.tab ===
                                                        "Instalação" &&
                                                        _r["nif"] ==
                                                            this.state.IdenUser[
                                                                this.props.tab
                                                            ] && (
                                                            <p
                                                                style={{
                                                                    marginTop:
                                                                        "5px",
                                                                    width: "100px",
                                                                }}
                                                                className="titular-tag"
                                                            >
                                                                Ident.
                                                                Propriétario
                                                            </p>
                                                        )}
                                                </div>
                                                <div className="d-flex mr-3">
                                                    {
                                                        <>
                                                            {" "}
                                                            {!_r["nif"] ==
                                                                this.state
                                                                    .IdenUser[
                                                                    this.props
                                                                        .tab
                                                                ] && (
                                                                <>
                                                                    <Tooltip
                                                                        anchorElement="target"
                                                                        position="top"
                                                                    >
                                                                        <span
                                                                            onClick={(
                                                                                row
                                                                            ) =>
                                                                                this.deleteEntry(
                                                                                    _r
                                                                                )
                                                                            }
                                                                        >
                                                                            {/* <i
                                                                                title="Remover"
                                                                                style={{
                                                                                    color: "#ff0000",
                                                                                }}
                                                                                className="mr-3 fas fa-minus-circle cursor-pointer condition-true"
                                                                            ></i> */}
                                                                        </span>
                                                                    </Tooltip>
                                                                </>
                                                            )}
                                                            {this.props.tab ===
                                                                "Instalação" && (
                                                                <>
                                                                    <Tooltip
                                                                        anchorElement="target"
                                                                        position="top"
                                                                    >
                                                                        <span
                                                                            data-toggle="modal"
                                                                            data-target="#vinica-left-explor-popup"
                                                                            onClick={() =>
                                                                                this.popUpDetailEntry(
                                                                                    _r
                                                                                )
                                                                            }
                                                                        >
                                                                            <i
                                                                                title="Adicionar"
                                                                                style={{
                                                                                    color: "#1faf4b",
                                                                                }}
                                                                                className="fas fa-plus-circle cursor-pointer condition-true"
                                                                            ></i>
                                                                        </span>
                                                                    </Tooltip>
                                                                    {/* <span data-toggle="modal" data-target='#vinica-left-explor-popup' onClick={() => {
                                          this.popUpDetailEntry(_r)}}><i className="fas fa-plus-circle cursor-pointer condition-false"></i></span> */}
                                                                </>
                                                            )}
                                                            {this.props.tab ===
                                                                "Utilizadores" && (
                                                                <>
                                                                    <Tooltip
                                                                        anchorElement="target"
                                                                        position="top"
                                                                    >
                                                                        <span
                                                                            onClick={(
                                                                                row
                                                                            ) =>
                                                                                this.deleteEntry(
                                                                                    _r
                                                                                )
                                                                            }
                                                                        >
                                                                            <i
                                                                                title="Remover"
                                                                                style={{
                                                                                    color: "#ff0000",
                                                                                }}
                                                                                className="mr-3 fas fa-minus-circle cursor-pointer condition-true"
                                                                            ></i>
                                                                        </span>
                                                                    </Tooltip>
                                                                </>
                                                            )}
                                                        </>
                                                    }
                                                </div>
                                            </span>
                                        </div>
                                    )
                            )
                        ) : this.props.tab === "Instalação" ? (
                            <div className="searct-found">
                                <img
                                    className="img-fluid"
                                    src="imgs/search-large-icon.png"
                                />
                                <p className="font-14">Novo proprietário</p>
                                <h5>
                                    Pesquise a entidade que pretende associar
                                    como proprietário a esta instalação vínica
                                </h5>
                            </div>
                        ) : (
                            this.props.tab === "Utilizadores" && (
                                <div className="searct-found">
                                    <img
                                        className="img-fluid"
                                        src="imgs/search-large-icon.png"
                                    />
                                    <p className="font-14">Novo utilizador</p>
                                    <h5>
                                        Pesquise a entidade que pretende
                                        associar como utilizador a esta
                                        instalação vínica
                                    </h5>
                                </div>
                            )
                        )}
                    </div>
                    <div
                        className="modal left-popup"
                        id="vinica-left-explor-popup"
                    >
                        <div className="modal-dialog modal-sm">
                            {this.state.popUpForm}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default VinicaListModalForm;
